module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, _vm.onSearchChange]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Søk")])])]), _vm._v(" "), _c('table', {
    staticClass: "mdl-data-table mdl-shadow--2dp"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.reportsLogs), function(log) {
    return _c('tr', {
      attrs: {
        "id": 'log-' + log.id
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(_vm.formatDate(log.created_at))
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(log.license.toUpperCase())
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(log.content)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(log.IP)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(log.user_name)
      }
    })])
  }), _vm._v(" "), (!_vm.reportsLogs.length && !_vm.$root.ui.isLoading()) ? _c('tr', [_c('td', {
    staticClass: "mdl-data-table__cell--non-numeric",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No logs")])]) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Dato")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Reg.Nr")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("IP")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Verksted")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71fdf1e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./reports/assets/src/components/ReportsLogs.vue
// module id = 68
// module chunks = 0